import Axios, { AxiosInstance } from 'axios';
import qs from 'qs';
import { ElMessage } from 'element-plus';
import { getStorage, removeStorage } from './utils';
import { useHostConfigStore } from '@/store/hostConfigStore';
const axios: AxiosInstance = Axios.create({
  timeout: 20000,
});

const operateRequest = Axios.create({
  timeout: 1000 * 40,
});

let isRefreshing = false; // 定义一个是否正在刷新token的标记
let retryRequests: any[] = []; // 定义一个空数组，承载请求队列
 
export const loginUrl = () => {
  return useHostConfigStore().host_config.VITE_AUTH_HOST + import.meta.env.VITE_LOGIN_PAGE + encodeURIComponent(useHostConfigStore().host_config.VITE_LOGIN_REDIRECT);
}

function refreshCodeFn(){
  const addr = btoa(window.location.href);

  localStorage.removeItem('refresh_token');
  localStorage.removeItem('access_token');

  const a = `${loginUrl()}&state=${addr}`;
  window.location.href = a;
}

// // 前置拦截器（发起请求之前的拦截）
axios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem('access_token')) {
      const token = localStorage.getItem('access_token');
      if (token) {
        config.headers.tokensso = token;
        config.headers['authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    console.log('config error');
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    if (response.data.code !== '0') {
      const addr = btoa(window.location.href);

      if (
        response.data.code === '10001' &&
        window.location.pathname != '/login' &&
        window.location.pathname != '/playback/login'
      ) {
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');

        window.location.href = loginUrl() + '&state=' + addr;
      } else if (response.data.code === '10003') {
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');

        window.location.href = loginUrl() + '&state=' + addr;
      } else if (
        response.data.code == '10002' &&
        window.location.pathname != '/login' &&
        window.location.pathname != '/playback/login'
      ) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenFun();
        }

        return new Promise((resolve) => {
          // 将resolve放进队列，用一个函数形式来保存，等token刷新后调用执行
          retryRequests.push(() => {
            resolve(axios(response.config));
          });
        });
      } else {
        ElMessage.error(response.data.message || '请求失败');
        return Promise.reject(response.data);
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      if (localStorage.getItem('refresh_token')) {
        // 刷新token
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenFun();
        }
        return new Promise((resolve) => {
          // 将resolve放进队列，用一个函数形式来保存，等token刷新后调用执行
          retryRequests.push(() => {
            resolve(axios(error.response.config));
          });
        });
      } else {
        // 没token
        refreshCodeFn();
      }
    } else {
      ElMessage.error('请求失败');
      return Promise.reject(error);
    }
  },
);

function refreshTokenFun() {
  try {
    Axios.post(
      `${useHostConfigStore().host_config.VITE_AUTH_HOST}/oauth/token`,
      qs.stringify({
        client_id: import.meta.env.VITE_CLIENT_ID,
        grant_type: 'refresh_token',
        client_secret: import.meta.env.VITE_CLIENT_SECRET,
        refresh_token: localStorage.getItem('refresh_token'),
      }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
      .then((response) => {
        const { access_token, refresh_token, user_name } = response.data;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        const account = { displayName: user_name };
        localStorage.setItem('account', JSON.stringify(account));
        // 刷新完毕继续请求数据
        retryRequests.forEach((cb) => cb());
        // 重试完清空这个队列
        retryRequests = [];
      })
      .catch(() => {
        refreshCodeFn();
      })
      .finally(() => {
        isRefreshing = false;
      });
  } catch (e) {
    console.error(e);
  }
}

operateRequest.interceptors.request.use((config) => {
  // @ts-ignore
  config.headers.withcredentials = true;
  if (localStorage.getItem('access_token')) {
    // @ts-ignore
    config.headers['authorization'] = `Bearer ${localStorage.getItem(
      'access_token',
    )}`;
  }

  return config;
});

operateRequest.interceptors.response.use(
  function (response) {
    const { url } = response.config as any;
    if (url?.includes('oauth')) {
      return response.data;
    } else {
      const { success, isSuccess, data, message: msg, code } = response.data;
      if (success || isSuccess || code === '0') {
        return { data, success };
      } else {
        if (response.data.errorCode === 'COM0011') {
          if (getStorage('refresh_token')) {
            removeStorage('access_token');

            if (!isRefreshing) {
              isRefreshing = true;
              refreshTokenFun();
            }
            return new Promise((resolve) => {
              // 将resolve放进队列，用一个函数形式来保存，等token刷新后调用执行
              retryRequests.push(() => {
                resolve(operateRequest(response.config));
              });
            });
          } else {
            // 没token
            refreshCodeFn();
          }
        }
         else {
          ElMessage.error(msg || '请求失败');

          return Promise.reject(msg);
        }
      }
    }
  },
  function (error) {
    ElMessage.error('请求失败');

    return Promise.reject(error);
  },
);

export const uatRequest = Axios.create({
  timeout: 1000 * 40,
});

const getUatToken = () => {
  return Axios.post(
    'https://auth-uat.zelostech.com.cn/oauth/token',
    qs.stringify({
      client_id: 'zelos_data_web',
      client_secret: 'zelos_data_web_123',
      grant_type: 'client_credentials',
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  ).then((response) => {
    const { access_token } = response.data;
    localStorage.setItem('uat_access_token', access_token);
    return access_token;
  });
};

uatRequest.interceptors.request.use(async (config) => {
  let token = localStorage.getItem('uat_access_token');
  if (!token) {
    try {
      token = 'ySeMfuj4Tze8bABoPlRUSBdhHON3dxGYk1IZIRPkGp1t6wA_Bst5kxgi8SUQQgQivgqpzdMOfftp2GEzkrnRsgV0MD234rFqfkSJrZbAizq_E453R_8TJlm3pyBY29KE';
    } catch (e) {
      console.error('Failed to get UAT token', e);
    }
  }
  
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor to handle 401 and retry
uatRequest.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const token = 'ySeMfuj4Tze8bABoPlRUSBdhHON3dxGYk1IZIRPkGp1t6wA_Bst5kxgi8SUQQgQivgqpzdMOfftp2GEzkrnRsgV0MD234rFqfkSJrZbAizq_E453R_8TJlm3pyBY29KE';
        originalRequest.headers['Authorization'] = `Bearer ${token}`;
        return uatRequest(originalRequest);
      } catch (e) {
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default axios;

export { operateRequest };
